module.exports = __webpack_public_path__ + "img/slide-7.3075e6ea.jpg";